/* Extrait du bloc {% javascript %} de sections/lcu-audio-examples.liquid.
   Shopify concatenait tous ces blocs dans compiled_assets/scripts.js,
   telecharge et EXECUTE sur toutes les pages, y compris celles qui ne
   rendent pas la section. Ce fichier ne part plus qu'avec elle.

   Le garde ci-dessous reproduit le comportement d'origine : Shopify
   n'executait le bloc qu'une fois par type de section, alors qu'une
   balise <script src> peut etre emise plusieurs fois si la section est
   ajoutee deux fois sur une page. */

if (!window.__lcuScriptsRun) window.__lcuScriptsRun = {};
if (!window.__lcuScriptsRun.lcu_audio_examples) {
  window.__lcuScriptsRun.lcu_audio_examples = true;

  (function () {
    'use strict';

    var TRACK_MAX = 1000;
    var section = document.getElementById('lcu-audio-examples');
    if (!section) return;

    var audio = section.querySelector('.lcu-audio__element');
    if (!audio) return;
    var playBtn = section.querySelector('.lcu-audio__play');
    var track = section.querySelector('.lcu-audio__track');
    var currEl = section.querySelector('.lcu-audio__current');
    var durEl = section.querySelector('.lcu-audio__duration');
    var prevBtn = section.querySelector('[data-action="prev"]');
    var nextBtn = section.querySelector('[data-action="next"]');

    var featStyle = section.querySelector('[data-featured-style]');
    var featMood = section.querySelector('[data-featured-mood]');
    var featVoice = section.querySelector('[data-featured-voice]');
    var featTitle = section.querySelector('[data-featured-title]');
    var featLyrics = section.querySelector('[data-featured-lyrics]');
    var featCover = section.querySelector('[data-featured-cover]');

    var items = section.querySelectorAll('.lcu-audio__item');
    var activeIndex = 0;
    var isScrubbing = false;
    var pendingSeekValue = null;
    var initialized = false;

    function fmt(s) {
      var m = Math.floor(s / 60);
      var ss = Math.floor(s % 60);
      return m + ':' + (ss < 10 ? '0' : '') + ss;
    }

    function stopOtherPlayers() {
      document.querySelectorAll('.lcu-audio-preview__card audio, .lcu-audio__element').forEach(function (a) {
        if (a !== audio && !a.paused) a.pause();
      });
    }

    function setTrackValue(value) {
      if (!track) return;
      var v = Math.max(0, Math.min(TRACK_MAX, Math.round(value)));
      track.value = v;
      track.style.setProperty('--progress', ((v / TRACK_MAX) * 100) + '%');
    }

    function syncUi(currentTime) {
      if (!audio.duration || !isFinite(audio.duration)) return;
      var t = Math.max(0, Math.min(currentTime, audio.duration));
      setTrackValue((t / audio.duration) * TRACK_MAX);
      if (currEl) currEl.textContent = fmt(t);
    }

    function seekToValue(value) {
      var v = Math.max(0, Math.min(TRACK_MAX, Number(value) || 0));
      setTrackValue(v);
      if (!audio.duration || !isFinite(audio.duration)) {
        pendingSeekValue = v;
        return;
      }
      pendingSeekValue = null;
      var nextTime = (v / TRACK_MAX) * audio.duration;
      if (currEl) currEl.textContent = fmt(nextTime);
      audio.currentTime = nextTime;
    }

    function finishScrubbing() {
      isScrubbing = false;
      syncUi(audio.currentTime);
    }

    function syncPaused() {
      if (!playBtn) return;
      playBtn.dataset.playing = 'false';
      playBtn.setAttribute('aria-label', 'Lecture');
      var ip = playBtn.querySelector('.lcu-audio__icon-play');
      var pp = playBtn.querySelector('.lcu-audio__icon-pause');
      if (ip) ip.removeAttribute('hidden');
      if (pp) pp.setAttribute('hidden', '');

      items.forEach(function (item) {
        var eqIcon = item.querySelector('.lcu-audio__item-eq');
        var playIcon = item.querySelector('.lcu-audio__item-play');
        if (eqIcon) eqIcon.setAttribute('hidden', '');
        if (playIcon) playIcon.removeAttribute('hidden');
      });
    }

    function syncPlaying() {
      if (!playBtn) return;
      playBtn.dataset.playing = 'true';
      playBtn.setAttribute('aria-label', 'Pause');
      var ip = playBtn.querySelector('.lcu-audio__icon-play');
      var pp = playBtn.querySelector('.lcu-audio__icon-pause');
      if (ip) ip.setAttribute('hidden', '');
      if (pp) pp.removeAttribute('hidden');

      items.forEach(function (item, i) {
        var eqIcon = item.querySelector('.lcu-audio__item-eq');
        var playIcon = item.querySelector('.lcu-audio__item-play');
        if (i === activeIndex) {
          if (playIcon) playIcon.setAttribute('hidden', '');
          if (eqIcon) eqIcon.removeAttribute('hidden');
        } else {
          if (eqIcon) eqIcon.setAttribute('hidden', '');
          if (playIcon) playIcon.removeAttribute('hidden');
        }
      });
    }

    function updateFeaturedUI(item) {
      if (featStyle) featStyle.textContent = item.dataset.style || '';
      if (featMood) featMood.textContent = item.dataset.mood || '';
      if (featVoice) featVoice.textContent = item.dataset.voice || '';
      if (featTitle) featTitle.textContent = item.dataset.title || '';
      if (featLyrics) {
        featLyrics.textContent = item.dataset.lyrics || '';
        featLyrics.style.display = item.dataset.lyrics ? '' : 'none';
      }
      if (featCover && item.dataset.cover) {
        featCover.src = item.dataset.cover;
      }
    }

    function loadTrack(index, autoplay, userInitiated) {
      if (index < 0 || index >= items.length) return;
      var item = items[index];
      var src = item.dataset.src;

      activeIndex = index;

      items.forEach(function (el) { el.classList.remove('is-active'); el.removeAttribute('aria-current'); });
      item.classList.add('is-active');
      item.setAttribute('aria-current', 'true');
      updateFeaturedUI(item);

      var wasPlaying = !audio.paused;
      audio.pause();
      pendingSeekValue = null;
      isScrubbing = false;

      setTrackValue(0);
      if (currEl) currEl.textContent = '0:00';
      if (durEl) durEl.textContent = '--:--';

      if (src) {
        audio.src = src;
        if (autoplay || wasPlaying) {
          stopOtherPlayers();
          var p = audio.play();
          if (p && typeof p.catch === 'function') p.catch(function () { syncPaused(); });
        } else {
          syncPaused();
        }
      } else {
        audio.removeAttribute('src');
        syncPaused();
      }

      if (userInitiated) item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    function init() {
      if (initialized) return;
      initialized = true;

      audio.addEventListener('loadedmetadata', function () {
        if (durEl) durEl.textContent = fmt(audio.duration);
        if (pendingSeekValue !== null) { seekToValue(pendingSeekValue); return; }
        syncUi(audio.currentTime);
      });

      audio.addEventListener('durationchange', function () {
        if (durEl && audio.duration && isFinite(audio.duration)) durEl.textContent = fmt(audio.duration);
        syncUi(audio.currentTime);
      });

      audio.addEventListener('timeupdate', function () {
        if (isScrubbing) return;
        syncUi(audio.currentTime);
      });

      audio.addEventListener('seeked', function () {
        if (isScrubbing) return;
        syncUi(audio.currentTime);
      });

      audio.addEventListener('play', function () { syncPlaying(); });
      audio.addEventListener('pause', function () { if (!audio.ended) syncPaused(); });

      audio.addEventListener('ended', function () {
        pendingSeekValue = null;
        isScrubbing = false;
        if (activeIndex < items.length - 1) {
          loadTrack(activeIndex + 1, true);
        } else {
          syncPaused();
          audio.currentTime = 0;
          if (currEl) currEl.textContent = '0:00';
          setTrackValue(0);
        }
      });

      if (track) {
        track.addEventListener('pointerdown', function () { isScrubbing = true; });
        track.addEventListener('input', function () { isScrubbing = true; seekToValue(track.value); });
        track.addEventListener('change', function () { seekToValue(track.value); finishScrubbing(); });
        track.addEventListener('pointerup', function () { finishScrubbing(); });
        track.addEventListener('pointercancel', function () { finishScrubbing(); });
        track.addEventListener('keyup', function () { seekToValue(track.value); finishScrubbing(); });
      }

      if (playBtn) {
        playBtn.addEventListener('click', function () {
          if (!audio.src && items[activeIndex]) {
            var src = items[activeIndex].dataset.src;
            if (src) audio.src = src;
          }
          if (audio.paused) {
            stopOtherPlayers();
            var p = audio.play();
            if (p && typeof p.catch === 'function') p.catch(function () { syncPaused(); });
          } else {
            audio.pause();
          }
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          var idx = activeIndex - 1;
          if (idx < 0) idx = items.length - 1;
          loadTrack(idx, !audio.paused, true);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          var idx = activeIndex + 1;
          if (idx >= items.length) idx = 0;
          loadTrack(idx, !audio.paused, true);
        });
      }

      items.forEach(function (item, i) {
        item.addEventListener('click', function () {
          if (i === activeIndex) {
            if (audio.paused) {
              if (!audio.src) {
                var src = item.dataset.src;
                if (src) audio.src = src;
              }
              stopOtherPlayers();
              var p = audio.play();
              if (p && typeof p.catch === 'function') p.catch(function () { syncPaused(); });
            } else {
              audio.pause();
            }
          } else {
            loadTrack(i, true, true);
          }
        });
      });

      if (items.length > 0) {
        updateFeaturedUI(items[0]);
      }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          init();
        }
      }, { rootMargin: '200px' });
      observer.observe(section);
    } else {
      init();
    }
  })();
}
